import { render } from "./VODChaptersTab.vue?vue&type=template&id=37054b90"
import script from "./VODChaptersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODChaptersTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODChaptersTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37054b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37054b90', __exports__)) {
    api.reload('37054b90', __exports__)
  }
  
  module.hot.accept("./VODChaptersTab.vue?vue&type=template&id=37054b90", () => {
    api.rerender('37054b90', render)
  })

}


export default __exports__